// extracted by mini-css-extract-plugin
export default {"input":"styles_input__D-SD5","error":"styles_error__i688y"};